import { Flex } from "@chakra-ui/react";
import React, { useEffect } from "react";
import "./App.css";
import Navigation from "./navigation";

export const getWindowDimensions = () => {
  const { innerHeight: height, innerWidth: width } = window;
  let fontSize = "1rem";
  let timeFontSize = "0.72rem";
  if (height < 1001 && width < 1920) {
    fontSize = "0.6rem";
    timeFontSize = "0.58rem";
  }
  return { height, width, fontSize, timeFontSize };
};

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = React.useState(
    getWindowDimensions()
  );
  React.useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowDimensions;
};
function App() {
  const { width, height } = useWindowDimensions();
  // console.log({ width, height });
  return (
    <Flex direction="column" w={width}>
      <Navigation />
    </Flex>
  );
}

export default App;
